import { Trans, useTranslation } from "react-i18next";
import { heroStats } from "@/mocks/siteData";
import { waLink } from "@/lib/links";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative min-h-[680px] lg:min-h-[780px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Arman Delivery rider on a motorbike in Yerevan at golden hour"
          className="w-full h-full object-cover object-top"
          src="https://readdy.ai/api/search-image?query=Professional%20automotive%20photography%20of%20a%20delivery%20rider%20on%20a%20modern%20motorcycle%20riding%20through%20Yerevan%20city%20streets%20at%20golden%20hour%20with%20Mount%20Ararat%20in%20distant%20background%2C%20photorealistic%2C%20warm%20amber%20sunlight%2C%20cinematic%20wide%20composition%2C%20sharp%20details%2C%20realistic%20editorial%20photo%20style&width=1920&height=1080&seq=arman-hero-02&orientation=landscape&nocache=true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-32 pb-20">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-background-50/10 backdrop-blur border border-background-50/20 text-background-50 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-6 animate-fade-up">
            <span className="w-2 h-2 rounded-full bg-primary-400" />
            {t("hero.badge")}
          </div>

          <h1 className="font-heading text-background-50 text-4xl md:text-6xl lg:text-7xl font-extrabold leading-[1.05] tracking-tight animate-fade-up">
            {t("hero.title1")}
            <br />
            <span className="text-primary-400">{t("hero.title2")}</span> {t("hero.title3")}
          </h1>

          <p className="mt-6 text-background-50/85 text-base md:text-xl leading-relaxed max-w-2xl animate-fade-up">
            <Trans
              i18nKey="hero.paragraph"
              values={{ brand: t("brand.full") }}
              components={{ b: <strong className="text-background-50 font-semibold" /> }}
            />
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 animate-fade-up">
            <a
              href={waLink(t("wa.hero"))}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-base px-7 py-4 rounded-md whitespace-nowrap cursor-pointer transition"
            >
              <i className="ri-whatsapp-line text-xl w-5 h-5 flex items-center justify-center" />
              {t("hero.ctaWhatsapp")}
            </a>
            <a
              href="#fleet"
              className="inline-flex items-center justify-center gap-2 bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 font-semibold text-base px-7 py-4 rounded-md whitespace-nowrap cursor-pointer transition backdrop-blur"
            >
              <i className="ri-eye-line text-xl w-5 h-5 flex items-center justify-center" />
              {t("hero.ctaFleet")}
            </a>
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl animate-fade-up">
            {heroStats.map((stat) => (
              <div key={stat.labelKey} className="border-l border-background-50/25 pl-4">
                <div className="font-heading text-background-50 text-2xl md:text-3xl font-extrabold">{stat.value}</div>
                <div className="text-background-50/70 text-xs md:text-sm font-medium mt-1">{t(stat.labelKey)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}